(function () {
    'use strict';

    class ProjectDetailsDateLocationComponent extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, $timeout, $translate, moment, _, DeviceService, CompaniesManager,
                    RescheduleProjectService, UsersManager) {
            super($scope, $injector);
            this.__objectType = 'ProjectDetailsDate';

            this.$timeout = $timeout;
            this.$translate = $translate;
            this.moment = moment;
            this._ = _;
            this.isMobileDevice = DeviceService.isIOS() || DeviceService.isAndroid();
            this.company = CompaniesManager.getCurrCompany();
            this.RescheduleProjectService = RescheduleProjectService;
            this.shouldShowDateConflicts = this.company.isShowDateConflictsAutomationOn();
            this.currentUser = UsersManager.getCurrUser();
        }

        $onInit() {
            this.lastDateLabel = this.dateLabel;
            this.lastLocationLabel = this.locationLabel;

            this.workspace = this.project ? this.project.workspaces.find((workspace)=> workspace._id === this.workspaceId) : null;
            this.userCanReschedule = this.RescheduleProjectService.userCanReschedule(this.currentUser, this.workspace);
        }

        $onChanges(changes) {
            if(changes.locationLabel) {
                this.lastLocationLabel = this.locationLabel;
            }
            else if(changes.dateLabel) {
                this.lastDateLabel = this.dateLabel;
            }
        }

        openRescheduleProjectModal() {
            this.RescheduleProjectService.openRescheduleModal(this.project, this.workspaceId, false, 'project_details');
        }

        onLocationFieldChange() {
            return this.onLocationChange && this.onLocationChange({changes: {location: this.location}});
        }

        onGoogleLocationChange(geocodeResult) {
            this.location = geocodeResult.formatted_address.includes(geocodeResult.name) ?
                     geocodeResult.formatted_address :
                    `${geocodeResult.name}, ${geocodeResult.formatted_address}`;
            this.onLocationFieldChange();
        }

        onDateLabelChange() {
            if(this.dateLabel) {
                const updated = this.onDateTimeChange({changes: {date_label: this.dateLabel}});
                if(updated) {
                    this.showDateError = false;
                }
                else {
                    this.dateLabel = this.lastDateLabel;
                    this.dateLabelError = this.$translate.instant('WORKSPACE.PROJECT_DETAILS._LABEL_ERROR_', {labelType: 'date'});
                    this.showDateError = true;
                }

            } else {
                this.dateLabel = this.lastDateLabel;
            }
        }

        onLocationLabelChange() {
            if(this.locationLabel) {
                const updated = this.onLocationChange({changes: {location_label: this.locationLabel}});
                if(updated) {
                    this.showLocationError = false;
                }
                else {
                    this.locationLabel = this.lastLocationLabel;
                    this.locationLabelError = this.$translate.instant('WORKSPACE.PROJECT_DETAILS._LABEL_ERROR_', {labelType: 'location'});
                    this.showLocationError = true;
                }
            } else {
                this.locationLabel = this.lastLocationLabel;
            }
        }

        addLocation() {
            this.onAddLocation();
        }

        deleteLocation() {
            return this.onDateTimeChange({changes: {location_label: null, location: null}});
        }

    }

    Components.ProjectDetailsDateLocation = {
        bindings: {
            dateLabel: '<?',
            startDate: '<',
            startTime: '<?',
            endDate: '<?',
            endTime: '<?',
            editMode: '<?',
            onDateTimeChange: '&?',
            showLocation: '<?',
            locationLabel: '<?',
            location: '<',
            onLocationChange: '&?',
            onAddLocation: '&?',
            onDeleteDate: '&?',
            showDateDeleteButton: '=',
            showLocationDeleteButton: '=',
            analyticsEventsSource: '=',
            projectId: '<?',
            onStartDateFocusCallback: '&?',
            project: '<',
            workspaceId: '<',
            branded: '<?'
        },

        controller: ProjectDetailsDateLocationComponent,
        name: 'hbProjectDetailsDateLocation',
        templateUrl: 'angular/app/modules/core/features/workspace/project_details/project_details_date_location_component_template.html'
    };

}());
